import { NavCount } from "components";
import { UsersDashboardFilters, UsersDashboardTable } from "modules/UsersDashboard/components";
import { useUsersQuery } from "modules/UsersDashboard/hooks";

export const UsersDashboard = () => {
  const { nbItems } = useUsersQuery();

  return (
    <>
      <NavCount total={nbItems} />
      <UsersDashboardFilters />
      <UsersDashboardTable />
    </>
  );
};
